module.exports = __webpack_public_path__ + "img/truckRearLeftOutline.82f2bc23.svg";